import { render } from "./Paginacao.vue?vue&type=template&id=1d8ebdeb&scoped=true&ts=true"
import script from "./Paginacao.vue?vue&type=script&lang=ts"
export * from "./Paginacao.vue?vue&type=script&lang=ts"

import "./Paginacao.vue?vue&type=style&index=0&id=1d8ebdeb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8ebdeb"]])

export default __exports__